module.exports = __webpack_public_path__ + "img/storyboard_lite_menuboards.53dad636.png";